module.exports = __webpack_public_path__ + "static/media/chef.215e1344.svg";